import './LoadUnexpectedModal.scss';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import Error from '../../../../common/Error/Error';
import LoadingSpinner from '../../../../common/LoadingSpinner/LoadingSpinner';
import GoodsOut from '../../../../api/controllers/GoodsOut/GoodsOut';
import Packages from '../../../../api/controllers/Packages/Packages';
import Button from '../../../../common/Button/Button';

// General LoadUnexpectedModal Component
const LoadUnexpectedModal = ({
  category,
  movementId,
  setModalOpen,
  packageId,
  refreshMovement,
}) => {
  const [error, setError] = useState();
  const [loading, setLoading] = useState();
  const [pkg, setPackage] = useState();

  const getPackage = () => {
    setLoading(true);
    Packages.show(packageId)
      .then(response => {
        setLoading(false);
        setPackage(response);
      })
      .catch(e => {
        setLoading(false);
        setError(e.errors || e.error);
      });
  };

  const loadUnexpected = () => {
    setLoading(true);
    GoodsOut.assign(category, movementId, pkg?.id)
      .then(() => {
        setLoading(false);
        refreshMovement();
        setModalOpen(false);
      })
      .catch(e => {
        setLoading(false);
        setError(e.errors || e.error);
      });
  };

  useEffect(() => {
    getPackage();
  }, []);

  return (
    <div className="load_unexpected_container">
      {loading && <LoadingSpinner />}
      {error && (
        <Error
          errorMessages={error}
          type={'error'}
          errorTitle={
            Array.isArray(error)
              ? `${error.length} error${error.length > 1 ? 's' : ''} occurred: `
              : ''
          }
        />
      )}
      <Error
        errorMessages={`Warning: ${pkg?.job?.jobReference} is not expected on this vehicle`}
        type={'info'}
      />
      <div className="affected_packages">
        <ul>
          <li>
            If you{`'`}re sure that this is what you want to do, tap
            <b className="orange"> continue anyway</b> to proceed.
          </li>
          <li>
            Otherwise, tap <b>cancel</b> to abort this action.
          </li>
        </ul>
      </div>
      <div className="load_unexpected_buttons">
        <Button
          buttonType={'orange'}
          className="load_button"
          onClick={() => loadUnexpected()}
          label="Continue anyway"
        />
        <Button
          buttonType={'grey'}
          className="cancel_button"
          onClick={() => setModalOpen(false)}
          label="Cancel"
        />
      </div>
    </div>
  );
};

LoadUnexpectedModal.propTypes = {
  category: PropTypes.string,
  movementId: PropTypes.number,
  packageId: PropTypes.number,
  setModalOpen: PropTypes.func,
  refreshMovement: PropTypes.func,
  modelName: PropTypes.string,
};

export default LoadUnexpectedModal;
